import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	taskOneDescriptionSiteAdminNonFinal: {
		id: 'eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-one-description-site-admin-non-final',
		defaultMessage: `
Use **Atlassian Administration** to manage your teams' access to Jira Service Management and other cloud products.\n
Users with the **product admin** role in Jira Service Management can manage the product's settings, including operations, while Users can use the product without any admin permissions.
        `,
		description:
			'Transition home users and roles step task one description when user is site admin',
	},
	goToAtlassianAdministrationButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.users-and-roles-step.site-admin.go-to-atlassian-administration-button-non-final',
		defaultMessage: 'Go to Atlassian Administration',
		description:
			'Transition home users and roles step go to atlassian administration button when user is site admin',
	},
	taskTwoDescriptionSiteAdminNonFinal: {
		id: 'eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-two-description-site-admin-non-final',
		defaultMessage: `
They are an admin in Opsgenie but aren't a product admin in Jira Service Management.\n
You can give them the **product admin** role in Jira Service Management so they can continue to have the access to configure operations.
[Read how to make someone a product admin](https://support.atlassian.com/user-management/docs/give-users-admin-permissions/#Make-someone-a-product-admin)
`,
		description:
			'Transition home users and roles step task two description when user is site admin',
	},
	taskTwoTableDescriptionSiteAdminNonFinal: {
		id: 'eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-two-table-description-site-admin-non-final',
		defaultMessage: "Opsgenie admins who don't have the product admin role:",
		description:
			'Transition home users and roles step task two table description when user is site admin',
	},
	taskTwoEmptyStateSiteAdminNonFinal: {
		id: 'eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-two-empty-state-site-admin-non-final',
		defaultMessage:
			'Users who were an Opsgenie admin are now a product admin in Jira Service Management. They have the access to configure operations.',
		description:
			'Transition home users and roles step task two empty state when user is site admin',
	},
	taskThreeDescriptionSiteAdminNonFinal: {
		id: 'eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-three-description-site-admin-non-final',
		defaultMessage: `
They have a custom role in Opsgenie that isn't supported by Jira Service Management, so they currently have a User role.\n
You can give them the **product admin** role in Jira Service Management so they can continue to have the access to configure operations.
[Read how to make someone a product admin](https://support.atlassian.com/user-management/docs/give-users-admin-permissions/#Make-someone-a-product-admin)
`,
		description:
			'Transition home users and roles step task three description when user is site admin',
	},
	taskThreeTableDescriptionSiteAdminNonFinal: {
		id: 'eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-three-table-description-site-admin-non-final',
		defaultMessage: 'Opsgenie users who no longer have custom roles:',
		description:
			'Transition home users and roles step task three table description when user is site admin',
	},
	taskThreeEmptyStateSiteAdminNonFinal: {
		id: 'eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-three-empty-state-site-admin-non-final',
		defaultMessage:
			"Users who had a custom role in Opsgenie that isn't supported by Jira Service Management are now given a different role.",
		description:
			'Transition home users and roles step task three empty state when user is site admin',
	},
	taskFourDescriptionSiteAdminNonFinal: {
		id: 'eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-four-description-site-admin-non-final',
		defaultMessage: `All the stakeholders from Opsgenie were synced with Jira Service Management as agents, so they'll continue to have product access.\n
You can invite more stakeholders to Jira Service Management via Atlassian Administration. They don't need an agent license to join Jira Service Management, if you're on the Premium or Enterprise plan. [Read how to invite stakeholders](https://support.atlassian.com/jira-service-management-cloud/docs/how-can-i-add-and-manage-internal-stakeholders/#Invite-stakeholders-to-Jira-Service-Management)`,
		description:
			'Transition home users and roles step task four description when user is site admin',
	},
});
